import * as Sentry from '@sentry/browser'
import useAxios from 'axios-hooks'
import type { UseAxiosResult } from 'axios-hooks'
import { fetchAPI } from 'libs/apis'

import { LIMIT_PAGE } from 'helpers/constants'

import type {
  IParamStaff,
  IStaff,
  ISchemaFormStaffFormPayload,
} from 'features/Staff'

const appendForm = <T>(form: FormData, data: T) => {
  Object.entries(data).map(async ([key, value]) => {
    if (key === 'imagePath' && typeof value === 'string') {
      return
    }

    if (key === 'imagePath') {
      form.append(key, value, 'avatar.jpg')

      return
    }

    form.append(key, value)
  })

  return form
}

export const useFindAll = (params?: IParamStaff): UseAxiosResult<IStaff[]> => {
  const path = `${window._env_.REACT_APP_API_MOCK_URL}/api/v1/staffs`
  const nextParams = {
    ...params,
    _limit: LIMIT_PAGE,
  }

  return useAxios({
    url: path,
    params: nextParams,
  })
}

export const updateStaff = async (
  id: string,
  body: ISchemaFormStaffFormPayload,
): Promise<void> => {
  const form = new FormData()
  const appendedForm = appendForm<ISchemaFormStaffFormPayload>(form, body)

  try {
    await fetchAPI({
      apiUrl: window._env_.REACT_APP_API_URL,
      method: 'PATCH',
      path: `/v1/user/${id}`,
      options: { data: appendedForm },
    })
  } catch (error) {
    Sentry.captureException(error)
  }
}
